"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Control",
            scope: "#/properties/visitDate",
            options: {
                disableFuture: true,
            },
        },
        (0, common_1.makeAppointmentUiSchema)("clinicianAppointment", "Next Clinician Visit", {
            disablePast: true,
        }),
        (0, common_1.makeAppointmentConflictsUiSchema)("clinicianAppointment"),
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
